import type {CreditBenefit} from '@Components/checkout-flow/components/credit-benefits-panel/credit-benefits-panel.types';

export const HOW_IT_WORKS_POINTS: readonly CreditBenefit[] = [
  {icon: 'icon-sparkle', titleKey: 'pmwjs_ai_verify_how_marks_title', descriptionKey: 'pmwjs_ai_verify_how_marks_desc', isAi: true},
  {icon: 'icon-lock', titleKey: 'pmwjs_ai_verify_how_private_title', descriptionKey: 'pmwjs_ai_verify_how_private_desc', isAi: false},
  {icon: 'icon-eye-off', titleKey: 'pmwjs_ai_verify_how_limits_title', descriptionKey: 'pmwjs_ai_verify_how_limits_desc', isAi: false},
];

export const HOW_IT_WORKS_HEADING_ID = 'ai-content-verify-how-it-works-heading';
